module.exports = require('./helpers/bundle-url').getBundleURL('kA4Du') + "logo.c51670a8.svg";